import { useEffect } from "react";

import { AppDispatch, useAppDispatch } from "../../redux";
import {
  getAllNotificationsAction,
  updateNotificationStatusAction,
} from "../../redux/dashboard/notification-slice";

import { bellIcon, bullet, letter } from "../../assets/img";
// import Icon from "../../assets/svg";
import Button from "../../components/button";
import { NotificationData } from ".";
import { formatNotificationDate } from "../../utils/functions";

type Props = {
  notifications: [];
};

async function markAllAsRead(
  dispatch: AppDispatch,
  notifications: NotificationData[]
): Promise<void> {
  const unread = notifications.filter((n: any) => n.status === "unread");

  const updatePromises = unread.map((notification) => {
    const updateData = {
      id: notification.id,
      slug: notification.slug,
      status: "read" as const,
    };
    // we assume this thunk returns a Promise
    return dispatch(updateNotificationStatusAction(updateData));
  });

  await Promise.all(updatePromises);
}

const NotificationDropDown = ({ notifications }: Props) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (notifications.length === 0) return;

    const params = {
      type: "",
      status: "",
    };

    const markRead = async () => {
      try {
        await markAllAsRead(dispatch, notifications);
        console.log("All unread notifications have been marked as read");
        await dispatch(getAllNotificationsAction(params));
      } catch (err) {
        console.error("Error marking notifications read:", err);
      }
    };

    markRead();
  }, []);

  const handleViewAllNotifications = () => {
    window.location.assign("/notifications");
  };

  return (
    <div className="notification_dropdown">
      <div className="topbar">
        <div className="left">
          <p>NOTIFICATIONS</p>
          <img src={bellIcon} alt="notification_icon" />
        </div>
        <div className="right">{/* <Icon name="close" /> */}</div>
      </div>
      <div className="content">
        {notifications
          // ?.filter((_notification: any, index: number) => index < 2)
          ?.map((notification: NotificationData) => (
            <div className="item" key={notification.id}>
              <div className="icon">
                <img src={letter} alt="" />
              </div>
              <div className="item_content">
                <p className="item_title">{notification.activity}</p>
                <p
                  className="item_detail"
                  // dangerouslySetInnerHTML={{
                  //   __html: `${notification.message}  <span>See more</span>`,
                  // }}
                  dangerouslySetInnerHTML={{
                    __html: `${notification.message}`,
                  }}
                ></p>

                <p className="item_detail">
                  {formatNotificationDate(notification.created_at)}
                </p>
              </div>
              <div className="bullet">
                <img src={bullet} alt="" />
              </div>
            </div>
          ))}

        {/* <div className="item">
          <div className="icon">
            <img src={graph} alt="" />
          </div>
          <div className="item_content">
            <p className="item_title">You have not reviewed your analytics</p>
            <p className="item_detail">
              You have some new data on your analytics page.{" "}
              <span>See more</span>
            </p>
            <p className="item_detail">27th May 2024, 12:32pm</p>
          </div>
          <div className="bullet">
            <img src={bullet} alt="" />
          </div>
        </div> */}
        <div className="button_div">
          <Button
            text={"See all notifications"}
            onClick={handleViewAllNotifications}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationDropDown;
